/* eslint-disable no-console */
import saga from 'Modules/payment/store/saga'
import reducer from 'Modules/payment/store/reducer'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { useDispatch, useSelector } from 'react-redux'
import { makeSelectPayment } from 'Modules/payment/store/selectors'
import { getPaymentList } from 'Modules/payment/store/actions'

export const usePayment = () => {
  useInjectSaga({ key: 'getPayment', saga })
  useInjectReducer({ key: 'getPayment', reducer })

  const { getPayment } = useSelector(
    makeSelectPayment()
  )

  const dispatch = useDispatch()
  const getPaymentAction = (payload) => dispatch(getPaymentList(payload))

  return {
    getPayment,
    getPaymentAction
  }
}
